<template>
    <div class="form-label">{{ label }} <span v-if="labelRequired" class="color-red">*</span></div>
    <div class="file-upload mt-2">
        <!-- Загрузка из локального источника -->
        <div class="file-upload__dropzone"
            :class="{ 'is-dragover': isDragOver }"
            @dragenter.stop.prevent="onDragEnter"
            @dragleave.stop.prevent="onDragLeave"
            @dragover.stop.prevent="onDragOver"
            @drop.stop.prevent="uploadFilesFromDropzone">

            <div class="file-upload__dropzone-text">
                <button class="file-upload__dropzone-btn btn btn-outline-primary" v-on:click.stop.prevent="uploadFileFromInputLocal" type="button">
                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.668 2.5v3.333a.834.834 0 00.833.834h3.334" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.001 17.5H5.835a1.667 1.667 0 01-1.667-1.667V4.167A1.667 1.667 0 015.835 2.5h5.833l4.167 4.167v3.75" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.668 14.583a2.083 2.083 0 104.167 0 2.083 2.083 0 00-4.167 0zM15.418 16.25l2.083 2.083" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <span>Обзор</span>
                </button>
                <span>Загрузите файл с устройства.</span>
                <span>Поддерживаемые форматы</span>
                <span><strong>{{ fileExtension }}</strong></span>
            </div>
            <input class="file-upload__local-input"
                :key="fileInputKey"
                type="file"
                name=""
                id=""
                :accept="fileExtension"
                :multiple="multiple_property"
                @change="uploaded"
            >
        </div>

        <div class="file-list" :class="{ border : fileNames.length }">
            <div class="file" v-for="file in fileNames">
                <a :href="link" class="text-decoration-none">{{ file }}</a>
                <svg @click="clearable ? removeFile(file) : null"
                    class="file-list__btn"
                    :class="!clearable ? 'disabled' : ''"
                    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_641_26163)">
                        <path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_641_26163">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "FileUploadElement",
    props: {
        multiple_property: {
            type: Boolean,
            default: true
        },
        picture_path: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'Загрузка файла'
        },
        labelRequired: {
            type: Boolean,
            default: false
        },
        fileExtension: {
            type: String,
            default: '.jpg, .mp4'
        },
        fileName: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: true
        },
        link: {
            type: String
        }
    },
    data: () => {
        return {
            source: 'upload',
            picked_file: [],
            boxVisible: false,
            fileInputKey: Date.now(), // ключ для форс-перерисовки input
            isDragOver: false
        };
    },
    emits: [
        'fileUpload'
    ],
    computed: {
        file() {
            return this.fileName !== '' ? this.fileName : this.picked_file;
        },
        fileNames() {
            this.updateFileList(Array.isArray(this.picked_file) ? this.picked_file : []);
            return Array.isArray(this.picked_file) ? this.picked_file : [];
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('fileUploader', ['updateFileList']),
        uploaded: function (e) {
            if (e.target.files.length > 0) {
                this.picked_file = [];
                for (let i = 0; i < e.target.files.length; i++) {
                    const file = e.target.files.item(i);
                    this.picked_file.push(file.name);
                    this.$emit('fileUpload', file);
                }

                this.boxVisible = false;
                this.fileInputKey = Date.now(); // Пересоздаем инпут чтобы метод срабатывал при повторной загрузке одинаковых файлов
            }
        },
        uploadFileFromInputLocal(e) {
            let fileInput = e.currentTarget.closest('.file-upload__dropzone').querySelector('.file-upload__local-input') || false;
            fileInput.click();
            //При клике на кнопку "Выберите файл" открываем скрытй файл-инпут, из которого дальше сможем передать файлы в formData
        },
        clearInput(e) {
            //Сбрасываем адрес в инпуте наверху
            // e.currentTarget.closest('.file-input-group').querySelector('.file-input-group__input').value = '';
            this.picked_file = [];
            this.$emit('fileUpload', false);
            if (this.picture_path === false) {
                this.boxVisible = true;
            }
        },
        //Остаётся добавить обработчики событий на кнопки Загрузить

        onDragEnter() {
            this.isDragOver = true;
        },
        onDragLeave() {
            this.isDragOver = false;
        },
        onDragOver(e) {
            if (!e) return;
            e.preventDefault();
            this.isDragOver = true;
        },
        uploadFilesFromDropzone(e) {
            const files = e.dataTransfer.files;

            if (files.length > 0) {
                this.picked_file = [];
                for (let i = 0; i < files.length; i++) {
                    const file = files.item(i);
                    const index = file.name.lastIndexOf(".");
                    const extension = index !== -1 ? file.name.substring(index) : "";

                    if (this.fileExtension.includes(extension)) {
                        this.picked_file.push(file.name);
                        this.$emit('fileUpload', file);
                    } else {
                        this.addAlert({ type: 'warning', title: 'Предупреждение', text: `Файл ${file.name} не соответствует формату ${this.fileExtension}`});
                    }
                }

                setTimeout(() => {
                    this.boxVisible = false;
                    this.fileInputKey = Date.now();
                }, 0);
            }

            this.isDragOver = false;
        },
        removeFile(name) {
            this.picked_file = this.picked_file.filter(file => file !== name);
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
    },
    watch: {
        fileName(val) {
            this.picked_file.push(val);
        }
    },
    mounted() {
        document.addEventListener('dragover', this.preventDefaults, false);
        document.addEventListener('drop', this.preventDefaults, false);
    },
    beforeUnmount() {
        document.removeEventListener('dragover', this.preventDefaults, false);
        document.removeEventListener('drop', this.preventDefaults, false);
    },
};
</script>

<style scoped lang="scss">
.file-input-group {
    display: flex;
    align-items: stretch;
    max-width: 526px;

    @media screen and (max-width: 767px) {
        max-width: unset;
    }

    &__input {
        pointer-events: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    &__reset,
    &__open {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        color: #A8A8A8;
        border: 1px solid #D1D1D1;
        border-left: none;
        transition: 50ms ease-in-out color;

        &:hover,
        &:focus-visible {
            outline: none;
            color: var(--accent);
        }
    }

    &__open.is-selected {
        color: var(--accent);
    }

    &__reset {
        width: 35px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}

.file-upload {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;

    &__subtext {
        margin-top: 4px;
        font-size: 12px;
        font-weight: 400;
        color: var(--black);
    }

    &__ctrls {
        padding-top: 12px;
        display: flex;
        align-items: stretch;
        gap: 12px;
        width: 100%;
        border-bottom: 1px solid var(--lighten-gray);
    }

    &__ya-title,
    &__local-title {
        font-weight: 600;
        font-size: 16px;
        text-align: center;

        @media screen and (max-width: 767px) {
            font-size: 12px;
        }
    }

    &__ya-title {
        grid-column: 2;
        grid-row: 1;
    }

    &__local-title {
        display: none;

        @media screen and (max-width: 575px) {
            display: block;
            text-align: left;
        }
    }

    &__dropzone {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        grid-column: 2;
        grid-row: 1/4;
        padding: 10px;
        border: 1px dashed var(--lighten-gray);
        border-radius: 5px;
        min-height: 196px;
        cursor: auto;
        pointer-events: auto !important;
        transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

        &.is-dragover {
            border-color: var(--accent);
            background-color: rgba(0, 123, 255, 0.05);
        }

        @media screen and (max-width: 575px) {
            grid-row: 2;
            grid-column: 1/3;
            padding: 0;
            min-height: unset;
            border: none;
        }
    }

    &__ya-link {
        grid-column: 2;
        grid-row: 2;

        @media screen and (max-width: 575px) {
            grid-column: 1/3;
        }
    }

    &__ya-up-btn-wrap {
        grid-column: 2;
        grid-row: 3;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__ctrl {
        padding: 6px 8px;
        border-bottom: 4px solid transparent;
        font-weight: 600;
        font-size: 14px;
        transition: 300ms border-color;

        &.is-selected {
            border-bottom: 4px solid var(--accent);
        }
        @media (hover: hover) and (pointer: fine) {
            &:hover {
                border-bottom: 4px solid var(--accent);
            }
        }
    }

    &__ya-link-label {
        margin-bottom: 10px;
        font-size: 16px;

        @media screen and (max-width: 767px) {
            margin-bottom: 7px;
            font-size: 12px;
        }
    }

    &__local-btn-wrap {
        display: flex;
        align-items: flex-end;
        grid-column: 1;
        grid-row: 3;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__dropzone-text {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-width: 300px;
        text-align: center;
    }

    &__dropzone-btn {
        margin-bottom: 8px;
    }

    &__local-input {
        position: absolute;
        margin-left: -1px;
        width: 1px;
        height: 1px;
        clip-path: inset(2px);
    }

    .file-list {
        &__btn {
            cursor: pointer;
        }
        &__btn:hover {
            path {
                stroke: red;
                transition: stroke 0.15s ease;
            }
        }
        p {
            margin: 0px;
        }
        .file {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            padding: 6px 10px;
        }
        .disabled {
            path {
                stroke: #D1D1D1;
                cursor: auto;
            }
        }
    }
}

.border {
    border: 1px solid rgb(193, 193, 193);
    border-radius: 6px;
}

.file-upload-btn {
    font-size: 14px;
    color: #00D515;
    text-align: left;
}
</style>
